import Config from "../../../Utils/Config";
import { EComponentTypes } from "../../../Utils/Enums";
import { InstructorModel, UserModel } from "../../../Utils/Models";
import { formatDate } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { localUrlEnum } from "../../../Utils/UrlEnum";

/**
 * Generates an array of column objects for the user salary report.
 */
// orderId is the hidden column at index 9
const ORDER_ID_INDEX = 9;

export const userSalaryColumn = [
  {
    name: "incrementId",
    label: Vocabulary.id,
  },
  {
    name: "clientName",
    label: Vocabulary.cursant,
    options: {
      customBodyRender: (value: string, tableMeta: any) => {
        const orderId = tableMeta.rowData[ORDER_ID_INDEX];
        if (!orderId) return value ?? "-";
        return (
          <a
            href={`${localUrlEnum.order}/${orderId}`}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ color: "inherit", textDecoration: "underline", cursor: "pointer" }}
          >
            {value ?? "-"}
          </a>
        );
      },
    },
  },
  {
    name: "instructorName",
    label: Vocabulary.instructor,
    options: {
      customBodyRender: (value: string) => {
        return value ?? "-";
      },
      exportValue: (value: string) => value ?? "-",
    },
  },
  {
    name: "officeAssistantName",
    label: Config.roles.OFFICE_ASSISTANT,
    options: {
      customBodyRender: (value: string) => {
        return value ?? "-";
      },
      exportValue: (value: string) => value ?? "-",
    },
  },
  {
    name: "description",
    label: Vocabulary.description,
  },
  {
    name: "amount",
    label: Vocabulary.amount,
    options: {
      customBodyRender: (value: number) => {
        return <span style={{ color: "#d32f2f", fontWeight: "bold" }}>{value}</span>;
      },
      exportValue: (value: number) => value ?? "",
    },
  },
  {
    name: "createdByUserName",
    label: Vocabulary.user,
  },
  {
    name: "createdAt",
    label: Vocabulary.createdAt,
    options: {
      customBodyRender: (value: Date) => {
        return formatDate(value);
      },
      exportValue: (value: Date) => value ? formatDate(value) : "",
    },
  },
  {
    name: "clientId",
    label: "",
    options: {
      display: "excluded" as any,
      filter: false,
      sort: false,
      download: false,
      print: false,
    },
  },
  {
    name: "orderId",
    label: "",
    options: {
      display: "excluded" as any,
      filter: false,
      sort: false,
      download: false,
      print: false,
    },
  },
];

/**
 * Generates an array of filter objects for the user salary report.
 *
 * @param {UserModel[]} officeAssitants - The list of users to use for the autocomplete filter.
 * @param {InstructorModel[]} instructors - The list of instructors to use for the autocomplete filter.
 *
 * @returns {Array<Filter>} An array of filter objects.
 */
export const userSalaryFilters = (
  officeAssitants: UserModel[],
  instructors: InstructorModel[]
) => [
  {
    property: "officeAssistantId",
    autocompleteFilterProperty: "_id",
    label: Config.roles.OFFICE_ASSISTANT,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: officeAssitants,
  },
  {
    property: "instructorId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.instructor,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: instructors,
  },
];
